var SearchView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

SearchView = (function() {
  function SearchView(gallery, options) {
    this.gallery = gallery;
    this.load = __bind(this.load, this);
    this.refresh = __bind(this.refresh, this);
    Observable(this, 'loaded', null);
    Observable(this, 'search_terms', null);
  }

  SearchView.prototype.refresh = function() {
    return this.loaded(null);
  };

  SearchView.prototype.load = function(search_terms) {
    this.search_terms = search_terms;
    if (this.search_terms !== '') {
      return this.loaded(Search({
        'gallery_id': this.gallery
      }, this.search_terms));
    } else {
      return this.refresh();
    }
  };

  return SearchView;

})();

//# sourceMappingURL=search.js.map
